/**
 * Storage key for persisted SIP configuration.
 */
export const PERSISTED_SIP_CONFIG = 'softphone:sip-config';

/**
 * Maximum age for persisted SIP config (24 hours).
 * After this time, the config is considered stale and should be refetched.
 */
export const SIP_CONFIG_MAX_AGE_MS = 24 * 60 * 60 * 1000;
